// GameButtons.js
import React, { useState } from 'react';
import { Box, Button, Typography, TextField } from '@mui/material';
import styles from './styles.module.css';

const GameButtons = ({ onUpdate, initialValues, hideHeader, onClose }) => {
    const [rows, setRows] = useState(
        initialValues || [
            { label: '1k', value: '1k' },
            { label: '100', value: '1' },
            { label: '50', value: '50' },
            { label: '100', value: '100' },
            { label: '50k', value: '50k' },
            { label: '13k', value: '13k' },
        ]
    );

    const handleLabelChange = (index, newLabel) => {
        setRows((prevRows) =>
            prevRows.map((row, i) =>
                i === index ? { ...row, label: newLabel } : row
            )
        );
    };

    const handleValueChange = (index, newValue) => {
        if (/^\d*k?$/.test(newValue)) { // Allow numbers or numbers with 'k'
            setRows((prevRows) =>
                prevRows.map((row, i) =>
                    i === index ? { ...row, value: newValue } : row
                )
            );
        }
    };

    const handleUpdate = () => {
        onUpdate(rows); // Send all rows to the parent component
        onClose(); // Close the dialog after updating
    };

    return (
        <Box>
            {!hideHeader && (
                <Box className={styles.Dialog_header}>
                    <Typography className={styles.betDialog_header_txt}>Set Button Value</Typography>
                </Box>
            )}
            <Box className={styles.Dialog_body}>
                <Box className={styles.Dialog_TextField_container_main}>
                    <Box className={styles.Dialog_TextField_container}>
                        <Typography className={styles.Dialog_body_TextField}>Price Label</Typography>
                        <Typography className={styles.Dialog_body_TextField}>Price Value</Typography>
                    </Box>
                </Box>
                <Box className={styles.Dialog_TextField_container_main}>
                    {rows.map((row, index) => (
                        <Box key={index} className={styles.Dialog_TextField_container}>
                            <Box className={styles.Dialog_body_TextField_container}>
                                <TextField
                                    value={row.label}
                                    onChange={(e) => handleLabelChange(index, e.target.value)}
                                    className={styles.Dialog_body_TextField}
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                            fontSize: '12px !important',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                            fontSize: '12px !important',
                                        },
                                    }}
                                />
                            </Box>
                            <Box className={styles.Dialog_body_TextField_container}>
                                <TextField
                                    value={row.value}
                                    onChange={(e) => handleValueChange(index, e.target.value)}
                                    size="small"
                                    className={styles.Dialog_body_TextField}
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                            fontSize: '12px !important',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                            fontSize: '12px !important',
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        onClick={handleUpdate}
                        className={styles.Update_btn}
                    >
                        <Typography className={styles.Update_btn_txt}>Update</Typography>
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default GameButtons;